/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What if I paste invalid encoded text?`)
};

const es_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si pego texto codificado inválido?`)
};

const de_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist, wenn ich ungültig kodierten Text einfüge?`)
};

const nl_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat gebeurt er als ik ongeldig gecodeerde tekst plak?`)
};

const fr_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il si je colle du texte codé invalide ?`)
};

const it_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cosa succede se incolla testo codificato non valido?`)
};

const pt_br2_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se colar texto codificado inválido?`)
};

const pt_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E se colar texto codificado inválido?`)
};

const ja_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なエンコードされたテキストを貼り付けた場合はどうなりますか?`)
};

const zh_ue_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果我粘贴了无效的编码文本会怎样？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq3_q", locale)
	if (locale === "en") return en_ue_faq3_q(inputs)
	if (locale === "es") return es_ue_faq3_q(inputs)
	if (locale === "de") return de_ue_faq3_q(inputs)
	if (locale === "nl") return nl_ue_faq3_q(inputs)
	if (locale === "fr") return fr_ue_faq3_q(inputs)
	if (locale === "it") return it_ue_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq3_q(inputs)
	if (locale === "pt") return pt_ue_faq3_q(inputs)
	if (locale === "ja") return ja_ue_faq3_q(inputs)
	return zh_ue_faq3_q(inputs)
};